<template>
    <div>
      <h1>企业简介</h1>
      <p class="content">
{{company}}是一个跨平台网络表演应用开发商，支持在线直播、群组对话、照片文字分享等，旗下有产品“{{webTitle}}”APP。
其团队来自于国内知名学府的精英团队，专注于直播表演、网站建设等。{{company}}一贯秉承经营精品娱乐内容的原则，以创新和服务为核心，加之有效的宣传推广，使得所设计开发的APP都有优异的市场回报，同时也为广大网民提供了种类更多、精彩纷呈的娱乐体验。

联系方式：邮箱:{{mail}}
联系地址：{{location}}
公司网站：{{host}}

      </p>
    </div>
</template>
<script>
import { webTitle, company, phone, mail, location } from '../../utils'

export default {
  name: 'help',
  computed: {
    host () {
      console.log(this.$route)
      return window.location.host
    },
    location () {
      return location()
    },
    webTitle () {
      return webTitle()
    },
    phone () {
      return phone()
    },
    mail () {
      return mail()
    },
    company () {
      return company()
    }
  }
}
</script>
<style lang="scss" scoped>
.content{
  padding:0 40px 0;
  white-space: pre-wrap;
  text-align: left;
}
</style>
